(ns machtfit.product-form.validation
  (:refer-clojure :exclude [time])
  (:require [cljs-time.core :as time]
            [clojure.string :as str]
            [machtfit.datetime :as datetime]
            [machtfit.human :as human]))

(defn validate
  "Return nil if validation passed, an error string otherwise.

  A validator should return nil if it considers the input valid, true if the input should be
  considered valid regardless of following validators (this is used to implement a validator
  'optional'), or an error string if the input is not valid."
  [value [first-validator & validators]]
  (when first-validator
    (let [result (first-validator value)]
      (case result
        true nil
        nil (validate value validators)
        result))))

(defn required [value]
  (when (str/blank? value) "Bitte ausfüllen."))

(defn optional [value]
  (if (str/blank? value) true nil))

(def ^:private supported-protocols
  #{"http" "https" "lotus" "notes"})

(defn- pretty-protocols []
  (str/join ", " (map #(str % "://") supported-protocols)))

(defn- protocol [value]
  (when value
    (let [[protocol' url-rest] (str/split value #"://" 2)]
      (when url-rest
        (str/lower-case protocol')))))

(defn is-link? [value]
  (protocol value))

(defn- valid-protocol? [value & {:keys [allow-empty?]}]
  (if-let [protocol' (protocol value)]
    (supported-protocols protocol')
    allow-empty?))

(defn website [value]
  (let [valid? (some? (re-matches #"(?i)(.*://)?[^/]+\.[^/]+.*" value))
        valid-protocol?' (valid-protocol? value :allow-empty? true)]
    (cond
      (not valid?) "Eventuell haben Sie sich verschrieben."
      (not valid-protocol?') (str "Erlaubte Protokolle sind: " (pretty-protocols)))))

(defn allowed-link-types [value]
  (when-not (or (re-matches #"(?i)mailto:(.*)" value)
                (valid-protocol? value))
    (str "Bitte geben Sie ein Protokoll an. Beispiel: " (pretty-protocols) " oder mailto:")))

(defn date [value]
  (let [parsed-date (datetime/string->date value)]
    (cond
      (nil? parsed-date) "Bitte geben Sie Tag und Monat ein."
      (not (<= 2000 (time/year parsed-date) 2030)) "Bitte geben Sie ein Jahr zwischen 2000 und 2030 ein.")))

(defn time [value]
  (when-not (some? (human/human->time value)) "Bitte geben Sie Stunden und Minuten ein."))

(defn amount [value]
  (when-not (some? (human/human->amount value)) "Bitte geben Sie einen Betrag ein."))

(defn positive-number [value]
  (let [valid? (some? (re-matches #"\d+" (str value)))]
    (when-not valid? "Nur positive Zahlen sind möglich.")))

(defn percent-number [value]
  (let [valid? (and (some? (re-matches #"\d+" (str value))) (>= value 0) (<= value 100))]
    (when-not valid? "Nur Zahlen zwischen 0 und 100 sind möglich.")))

(defn decimal-point [value]
  (cond-> value
    (string? value) (str/replace "," ".")))

(defn percent-decimal [value]
  (let [n (js/Number (decimal-point value))
        valid? (and (>= n 0) (<= n 100))]
    (when-not valid? "Nur Zahlen zwischen 0 und 100 sind möglich.")))

(defn max-length [n]
  (fn [value]
    (when (> (count value) n)
      (str "Maximal " n " Zeichen erlaubt."))))
